import { render, staticRenderFns } from "./customerReceAccount.vue?vue&type=template&id=9a439b0a"
import script from "./customerReceAccount.vue?vue&type=script&lang=js"
export * from "./customerReceAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports